__turbopack_context__.v({
  "editableTitle": "BlockHead-module-scss-module__v6b3uW__editableTitle",
});
